import { CardMedia, CardProps } from '@portals/core/src/components/Card/Card';
import Image from 'next/image';
import React from 'react';

import { File as FileModel } from '../../../models';

export const MEDIA_SIZES = {
  lg: '(min-width: 1600px) 75vw, (min-width: 720px)  75vw, 100vw',
  md: '(min-width: 1600px) 50vw, (min-width: 720px)  50vw, 100vw',
  sm: '(min-width: 1600px) 30vw, (min-width: 720px)  33vw, 100vw',
};

interface MediaProps {
  media: FileModel;

  aspectWidth: number;
  aspectHeight: number;

  mediaSizes?: string;

  sx?: CardProps['sx'];
}

export const AspectMedia: React.FunctionComponent<MediaProps> = ({
  media,
  aspectWidth,
  aspectHeight,
  mediaSizes = MEDIA_SIZES.sm,
  sx,
}: MediaProps) => {
  const height = Math.trunc((media.width / aspectWidth) * aspectHeight);

  if (Math.abs(height - media.height) > 1) {
    // eslint-disable-next-line no-console
    console.warn('Found Image not confirming aspectRatio', 'got', media.height, 'need', height);
  }

  return (
    <CardMedia sx={{ display: 'block', aspectRatio: `${aspectWidth}/${aspectHeight}`, ...sx, position: 'relative' }}>
      <Image
        style={{
          objectFit: 'contain',
          maxWidth: '100%',
          display: 'block',
          backgroundColor: '#292929',
          lineHeight: '1.5',
          fontFamily: 'monospace',
          fontSize: '16px',
          color: 'white',
        }}
        src={media.url}
        alt={media.alternativeText || ''}
        fill={true}
        sizes={mediaSizes}
      />
    </CardMedia>
  );
};
